import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=8e60aba4&scoped=true"
import script from "./Telephone.vue?vue&type=script&lang=js"
export * from "./Telephone.vue?vue&type=script&lang=js"
import style0 from "./Telephone.vue?vue&type=style&index=0&id=8e60aba4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e60aba4",
  null
  
)

export default component.exports